import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import {
  ANALYSIS_SET
} from '../mutations-types'

const state = {
  analysis: null
}

const getters = {
  analysis: state => state.analysis
}

const mutations = {
  [ANALYSIS_SET] (state, payload) {
    Vue.set(state, 'analysis', payload)
  },
}

const actions = {
  ANALYSIS_REQUEST_GET ({commit, rootState}, data) {
    let payload = {
      isBuyer: false,
      isResident: true,
      isShortSaleOrForeclosure: data.purchase.isShortSaleOrForeclosure,
      purchasePrice: null,
      purchaseDate: null,
      appraisedValue: null,
      appraisalAsOfDate: null,
      targetAppealTypes: [],
      affiliateCode: data.affiliateCode
    }

    //---isBuyer
    if (data.purchase.purchaseDate !== null) {
      payload.isBuyer = !(moment(data.purchase.purchaseDate).diff(moment()) < 0);
    }

    //---purchasePrice & purchaseDate
    if (data.purchase.purchasePrice !== null && data.purchase.purchaseDate !== null) {
      payload.purchasePrice = parseFloat(data.purchase.purchasePrice);
      payload.purchaseDate = moment(data.purchase.purchaseDate).format('L');
    } else {
      payload.purchasePrice = 99999999;
      payload.purchaseDate = moment().year(moment().year() - 4).format('L');
    }
    //---targetAppealTypes
    if (moment().diff(moment(payload.purchaseDate), 'years') < 3) {
      payload.targetAppealTypes.push(5)
    } else {
      payload.targetAppealTypes .push(2)
    }

    return new Promise((resolve, reject) => {
      Vue.axios.post('analysis/' + data.propertyAddressId + '/full-analysis/' + new Date().getFullYear(), payload)
        .then(response => {
          //---suggestedAppealsId
          //---assessment(Lack of Uniformity) === 2
          //---market(Market Overvaluation) === 5 or 6
          let analysis = _.assign({}, response.data, {
            purchase: {
              purchasePrice: payload.purchasePrice,
              purchaseDate: payload.purchaseDate
            },
            pdfPurchase: {
              pprice: data.purchase.purchasePrice ? parseFloat(data.purchase.purchasePrice) : null,
              pdate: data.purchase.purchaseDate ? moment(data.purchase.purchaseDate).format('L') : null,
            },
            suggestedAppeal: {
              id: response.data.suggestedAppeals[0].id,
              description: response.data.suggestedAppeals[0].description
            },
          })
          commit(ANALYSIS_SET, analysis);
          resolve();
        }).catch( error => {
          reject(error.response.data && error.response.data.message ? error.response.data.message: error.response.data ? error.response.data: error.response)
        });
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
